import { AnalyticsReportFeedbackRating } from "@redotech/crdb-enums/analytics/analytics-report-feedback-rating";
import * as z from "zod";

export const CUSTOM_ANALYTICS_REPORT_FEEDBACK_COMMENT_MAX_LENGTH = 1000;

export const CustomAnalyticsReportFeedbackSchema = z.object({
  rating: z.enum(AnalyticsReportFeedbackRating),
  comment: z.string().nullable(),
});

export type CustomAnalyticsReportFeedback = z.infer<
  typeof CustomAnalyticsReportFeedbackSchema
>;
